import {
  Component,
  Input,
  OnInit,
  Renderer2,
  ViewChild,
  ChangeDetectorRef,
} from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { CommonService } from "../services/common.service";
import { DomSanitizer } from "@angular/platform-browser";
import { environment } from "../../environments/environment";
import { SidebarStateService } from "../services/sidebar-state.service";
import { ToastrService } from "ngx-toastr";
import { MenuService } from "../services/menu.service";
import { filter } from "rxjs/operators";
import { MultiSelectComponent } from "ng-multiselect-dropdown";
import { HttpClient } from "@angular/common/http";
import { RoleChangeService } from "../services/role-change.service";
const url = environment.fileUrl;
// declare var onloadfn: any;
// declare var loadCr: any;
declare var $: any;
@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.css"],
})
export class SidebarComponent implements OnInit {
  @ViewChild("dropdown", { static: false }) dropdown: MultiSelectComponent;
  roleId: any = localStorage.getItem("RoleId") || 3;
  tenantCode: any = localStorage.getItem("TenantCode");
  roleName: any = localStorage.getItem("RoleName");
  applicantId: any = localStorage.getItem("IsApplicant");
  isApplicant: any;
  menus: Array<any> = [];
  clientLogo: any;
  isLogo: boolean = false;
  url: any;
  selectedMenuItem: any = "Dashboard"; // Initialize with 'Dashboard' or the default active item
  lastSelectedMenuItem: any = null; // Initialize as null
  isShow: any = localStorage.getItem("UserBaseSidebarMenu");
  isSubmit: any = localStorage.getItem("isStudent");
  isExpanded: boolean;
  currentMenu: any;
  allChilds: any[] = [];
  dropdownSettings: any = {};
  selectedMenu: any = [];
  SMHRUrl = localStorage.getItem("SMHRUrl");
  base64Image = `data:image/png;base64,${localStorage.tnt_logo}`;
  @Input() sMaduleId: any = 1;
  desiredUrl: any;
  openMenus: Set<string> = new Set();

  constructor(
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private router: Router,
    private service: CommonService,
    private sanitizer: DomSanitizer,
    private sidebarStateService: SidebarStateService,
    private toastr: ToastrService,
    private menuService: MenuService,
    private http: HttpClient,
    private roleChangeService: RoleChangeService
  ) {
    this.loadScript();
    // this.getMenu();

    this.sidebarStateService.isExpanded$.subscribe((isExpanded) => {
      this.isExpanded = isExpanded;
    });

    if (localStorage.getItem("Logo") == "") {
      this.isLogo = true;
    } else {
      this.isLogo = false;
    }
  }
  async ngOnChanges(changes: any) {
    if (+changes.sMaduleId.currentValue) {
      this.getMenu();

      const decryptedValue: any = await this.service.decryptAesGcm(
        localStorage.getItem("RoleId")!,
        this.service.key
      );
      let roleID = decryptedValue;
      // if (
      //   (roleID == "3" || roleID == "1" || roleID == "2") &&
      //   this.applicantId != "1"
      // ) {
      //   this.getMoodleUrl();
      // }
    }
    this.dropdownSettings = {
      singleSelection: true,
      idField: "path",
      textField: "Name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
      enableCheckAll: false,
    };
  }
  async ngOnInit() {
    const decryptedValue: any = await this.service.decryptAesGcm(
      this.roleId,
      this.service.key
    );
    this.roleId = decryptedValue;
    this.isApplicant =
      this.roleId == "3" || this.roleId == 3 || this.applicantId === "1";
    console.log(this.isApplicant);

    this.isShow =
      this.roleId == "3" || this.roleId == 3
        ? localStorage.getItem("UserBaseSidebarMenu")
        : "true";
    this.url = window.location.pathname;
    this.clientLogo = this.sanitizer.bypassSecurityTrustResourceUrl(
      `data:image/png;base64, ${localStorage.getItem("Logo")}`
    );
    if (this.sMaduleId !== 1) {
      this.getMenu();
      // let roleID = atob(localStorage.getItem("RoleId")!);
      const decryptedValue: any = this.service.decryptAesGcm(
        localStorage.getItem("RoleId")!,
        this.service.key
      );
      let roleID = decryptedValue;
      if (
        (roleID == "3" || roleID == "1" || roleID == "2") &&
        this.applicantId != "1"
      ) {
        this.getMoodleUrl();
      }
      this.sMaduleId = localStorage.getItem("RoleId");
    }
  }
  ngAfterViewInit(): void {
    // Add click listener to close sidebar on mobile when any menu link is clicked
    setTimeout(() => {
      const sidebar = document.getElementById('sidebar');
      if (sidebar) {
        const allLinks = sidebar.querySelectorAll('a');
        allLinks.forEach(link => {
          link.addEventListener('click', () => {
            if (window.matchMedia("(max-width: 991px)").matches) {
              // Don't close if it's a parent menu with children
              if (!link.classList.contains('has-arrow')) {
                setTimeout(() => {
                  // Remove toggled from body-wrapper
                  const bodyWrapper = document.querySelector('.body-wrapper');
                  if (bodyWrapper) {
                    bodyWrapper.classList.remove('toggled');
                  }
                  
                  // Remove toggled from all wrapper elements
                  const wrappers = document.querySelectorAll('.wrapper.toggled');
                  wrappers.forEach(w => w.classList.remove('toggled'));
                  
                  // Also remove from sidebar by ID
                  const sidebarEl = document.getElementById('sidebar');
                  if (sidebarEl) {
                    sidebarEl.classList.remove('toggled');
                  }
                  
                  this.openMenus.clear();
                }, 150);
              }
            }
          });
        });
      }
    }, 1000);
  }
  getClass(name) {
    return "mdi " + name + " menu-icon";
  }
  loadScript() {
    const script = this.renderer.createElement("script");
    script.src = "assets/plugins/metismenu/js/metisMenu.min.js";
    script.async = true;
    script.defer = true;
    this.renderer.appendChild(document.body, script);
  }
  getMoodleUrl() {
    let payload = {
      WSTOKEN: localStorage.getItem("MoodleTkn"),
      username: localStorage.getItem("MoodleUserName"),
      COURSE_ID: 0,
    };
    this.service.activateSpinner();
    this.service
      .postCall("MoodleIntegration/GetMoodleRequestLoginURL", payload)
      .subscribe(
        (res: any) => {
          if (res?.userToken) {
            localStorage.setItem("MoodleTkn", res.userToken);
          }
          // localStorage.setItem;
          let splitUrl = res.LoginUrl.split("&wantsurl=");
          this.desiredUrl = splitUrl[0];
          window.open(this.desiredUrl);
          event.preventDefault();
          this.service.deactivateSpinner();
        },
        (e) => {
          this.toastr.error(
            e.error.message == null ? "User doesn't exist on LMS" : ""
          );
          this.service.deactivateSpinner();
        }
      );
  }
  navigate(path: string, menu: any, event?: Event, level: number = 1) {
    const isMobile = window.matchMedia("(max-width: 991px)").matches;
    
    if (menu.Name == "LMS" || menu.Name == "SOMAS") {
      this.getMoodleUrl();
      if (isMobile) {
        setTimeout(() => this.closeLeftMenuforMobile(), 100);
      }
      return;
    }
    
    // Check if menu has children and we're on mobile
    if (menu.childs && menu.childs.length > 0 && isMobile) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      this.toggleMenu(menu.Name, level);
      return;
    }

    if (menu.Name === "Dashboard") {
      if (this.selectedMenuItem !== "Dashboard") {
        this.lastSelectedMenuItem = this.selectedMenuItem;
      }
      if (isMobile) {
        setTimeout(() => this.closeLeftMenuforMobile(), 100);
      }
    } else {
      this.selectedMenuItem = menu.Name;
      localStorage.setItem("menuName", this.selectedMenuItem);
      if (this.selectedMenuItem != "My Student Registration") {
        sessionStorage.setItem("reloaded", "false");
      }

      // If menu has no children (leaf node)
      if (!menu.childs || menu.childs.length === 0) {
        if (path) {
          let url = this.url.replaceAll("/OneApp/", "");
          let findPath = JSON.stringify(this.menus).includes(path || url);
          if (findPath) {
            this.router.navigate(["OneApp/" + path]);
          }
        }
        // ALWAYS close sidebar on mobile for leaf nodes
        if (isMobile) {
          setTimeout(() => this.closeLeftMenuforMobile(), 100);
        }
        return;
      }
    }
  }

  toggleMenu(menuName: string, level: number = 1) {
    if (this.openMenus.has(menuName)) {
      // Close this menu and all its children
      this.closeMenuAndChildren(menuName);
    } else {
      // Close all menus at the same level before opening this one
      if (level === 1) {
        // For top-level menus, close all other top-level menus
        this.openMenus.clear();
      } else {
        // For submenus, close sibling menus at the same level
        this.closeSiblingMenus(menuName, level);
      }
      this.openMenus.add(menuName);
    }
  }

  closeMenuAndChildren(menuName: string) {
    // Remove the menu itself
    this.openMenus.delete(menuName);
    
    // Find and close all child menus
    const menusToClose = Array.from(this.openMenus).filter(name => 
      this.isChildMenu(menuName, name)
    );
    menusToClose.forEach(name => this.openMenus.delete(name));
  }

  closeSiblingMenus(menuName: string, level: number) {
    // Close menus at the same level (siblings)
    const allMenuNames = this.getAllMenuNames(this.menus);
    const currentParent = this.getParentMenuName(menuName, allMenuNames);
    
    Array.from(this.openMenus).forEach(openMenu => {
      const openMenuParent = this.getParentMenuName(openMenu, allMenuNames);
      if (openMenuParent === currentParent && openMenu !== menuName) {
        this.closeMenuAndChildren(openMenu);
      }
    });
  }

  isChildMenu(parentName: string, childName: string): boolean {
    // Check if childName is a descendant of parentName in the menu tree
    const findInMenu = (items: any[], parent: string): boolean => {
      for (const item of items) {
        if (item.Name === parent && item.childs) {
          return this.menuContains(item.childs, childName);
        }
        if (item.childs && item.childs.length > 0) {
          if (findInMenu(item.childs, parent)) {
            return true;
          }
        }
      }
      return false;
    };
    return findInMenu(this.menus, parentName);
  }

  menuContains(items: any[], menuName: string): boolean {
    for (const item of items) {
      if (item.Name === menuName) {
        return true;
      }
      if (item.childs && item.childs.length > 0) {
        if (this.menuContains(item.childs, menuName)) {
          return true;
        }
      }
    }
    return false;
  }

  getAllMenuNames(items: any[]): any[] {
    let names: any[] = [];
    items.forEach(item => {
      names.push({ name: item.Name, parent: null });
      if (item.childs && item.childs.length > 0) {
        names = names.concat(this.getChildMenuNames(item.childs, item.Name));
      }
    });
    return names;
  }

  getChildMenuNames(items: any[], parentName: string): any[] {
    let names: any[] = [];
    items.forEach(item => {
      names.push({ name: item.Name, parent: parentName });
      if (item.childs && item.childs.length > 0) {
        names = names.concat(this.getChildMenuNames(item.childs, item.Name));
      }
    });
    return names;
  }

  getParentMenuName(menuName: string, allMenus: any[]): string | null {
    const menu = allMenus.find(m => m.name === menuName);
    return menu ? menu.parent : null;
  }

  isMenuOpen(menuName: string): boolean {
    return this.openMenus.has(menuName);
  }
  navigateToOuk() {
    // window.open('https://ouk.ac.ke/')
    this.router.navigate(["/OneApp/dashboard"]);
    if (window.matchMedia("(max-width: 991px)").matches) {
      setTimeout(() => this.closeLeftMenuforMobile(), 100);
    }
  }
  updateCurrentMenu(url: string): void {
    let currentUrl = url.replace("/OneApp/", "");
    this.currentMenu = this.findParentObject(this.menus, currentUrl);
    // console.log(this.currentMenu,'current Menu',currentUrl);
  }
  findParentObject(menus: any, currentPath: any): any {
    const paths = [
      "registration/editUserRegistration",
      "registration/profile",
      "registration/editRegistrationForm",
      "components/regForm",
    ];
    if (currentPath === "dashboard") {
      return "Dashboard";
    } else if (currentPath.includes("components/payment")) {
      return "Fees Accounts";
    } else if (paths.some((path) => currentPath.includes(path))) {
      return "Personal Info";
    } else if (currentPath === "components/prnlDetailsRegForm") {
      return "Personal Details Registration";
    } else if (currentPath === "myApplication") {
      return "My Application";
    }

    for (const menu of menus) {
      // Check if the current menu path matches the current path
      if (menu.path === currentPath) {
        return menu.Name;
      }
      if (menu.childs && menu.childs.length > 0) {
        for (const child of menu.childs) {
          if (child.path === currentPath) {
            return menu.Name;
          } else if (child.isParent && child.childs.length > 0) {
            const result = this.findParentObject(child.childs, currentPath);
            if (result) {
              return menu.Name;
            }
          }
        }
      }
    }
    return null;
  }
  getMenu() {
    let applicantId = localStorage.getItem("IsApplicant");
    let payLoad = {
      Roleid_base64string:
        applicantId == "0" || applicantId == "2"
          ? localStorage.getItem("RoleId")
          : localStorage.getItem("ApplicantRoleId"),
      USER_ID: parseInt(localStorage.getItem("UserId") as any),
      TENANT_CODE: parseInt(localStorage.getItem("TenantCode") as any),
    };

    this.service.postCall("Account/LoadMenusByRoleId", payLoad).subscribe(
      (res: any[]) => {
        this.menus = res;
        // let rId = atob(localStorage.getItem("RoleId")!);
        const decryptedValue: any = this.service.decryptAesGcm(
          localStorage.getItem("RoleId")!,
          this.service.key
        );
        let rId = decryptedValue;
        // let libraryMenu = {
        //   Name: "Library",
        //   path: "",
        //   CssClass: "fas fa-book-open",
        //   childs: [
        //     {
        //       Name: "KOHA OUK Library",
        //       path: "http://elibrary.ouk.ac.ke:8080/",
        //       target: "_blank",
        //     },
        //     {
        //       Name: "OUK OPAC Library",
        //       path: "https://elibrary.ouk.ac.ke/",
        //       target: "_blank",
        //     },
        //     {
        //       Name: "My LOFT OUK Library",
        //       path: "https://admin.myloft.xyz",
        //       target: "_blank",
        //     },
        //   ],
        // };

        // if (this.roleId == 1) {
        //   this.menus.splice(this.menus.length - 1, 0, libraryMenu); // Insert at second-last
        // } else if (this.roleId == 3) {
        //   this.menus.splice(this.menus.length - 2, 0, libraryMenu); // Insert at third-last
        // }

        this.menus = [...this.menus];
        this.menuService.setMenus(this.menus);
        let currentURL = window.location.pathname;
        this.allChilds = this.getAllChilds(this.menus);
        if (rId == "2") {
          return this.router.navigate(["/OneApp/dashboard"]);
        } else {
          this.updateCurrentMenu(currentURL);
          this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
              if (event.urlAfterRedirects.includes("OneApp")) {
                this.updateCurrentMenu(event.urlAfterRedirects);
              }
            });
        }

        // setTimeout(() => {
        //   if (onloadfn) {
        //     onloadfn();
        //   }
        //   if (loadCr) {
        //     loadCr();
        //   }
        // }, 100)
        return;
        let isSubmitbool: any = localStorage.getItem("isStudent");
        let roleId: any = atob(this.roleId);
        // Check if 'isSubmitbool' is not null or undefined and convert it to boolean
        if (
          isSubmitbool &&
          isSubmitbool.toLowerCase() === "false" &&
          roleId == 3
        ) {
          // Filter menu items to include only required items for students
          this.menus = this.menus.filter((item) => {
            return (
              item.Name === "My Program" ||
              item.Name === "My Application" ||
              item.Name === "My Student Registration"
            );
          });
        }
        // Handle navigation or further processing of filtered menus here if needed
      },
      (err) => {
        this.toastr.error("Something went wrong");
        this.router.navigate(["/login"]);
        localStorage.clear();
        sessionStorage.clear();
        // Handle error
      }
    );
  }

  getId(id: any) {
    return id.replaceAll(/\s/g, "");
  }

  closeLeftMenuforMobile() {
    if (window.matchMedia("(max-width: 991px)").matches) {
      // Target body-wrapper
      const bodyWrapper = document.querySelector('.body-wrapper');
      if (bodyWrapper) {
        bodyWrapper.classList.remove('toggled');
      }
      
      // Target the wrapper element (which is the sidebar)
      const wrappers = document.querySelectorAll('.wrapper.toggled');
      wrappers.forEach(wrapper => {
        wrapper.classList.remove('toggled');
      });
      
      // Also target by ID
      const sidebar = document.getElementById("sidebar");
      if (sidebar) {
        sidebar.classList.remove("toggled");
      }
      
      // Close all open menus
      this.openMenus.clear();
    }
  }
  userGuide() {
    const URL = `${url}home/KNA/OUK-StudentRegistration-UserGuide.pdf`;
    window.open(URL);
  }
  navigateToLibraryUrl(url: any) {
    window.open(url);
  }

  flattenChilds(node: any): any[] {
    let result: any[] = [];
    if (node.childs && node.childs.length > 0) {
      node.childs.forEach((child) => {
        result.push(child);
        result = result.concat(this.flattenChilds(child));
      });
    }
    return result;
  }

  getAllChilds(data: any[]): any[] {
    let allChilds: any[] = [];
    data.forEach((item) => {
      allChilds = allChilds.concat(this.flattenChilds(item));
    });
    return allChilds;
  }

  SearchMenuNav() {
    $("#staticBackdrop").modal("show");
    if (window.matchMedia("(max-width: 991px)").matches) {
      setTimeout(() => this.closeLeftMenuforMobile(), 100);
    }
  }

  onItemSelect(item: any) {
    if (item.path.split("/").length > 2) {
      this.cdr.detectChanges();
      this.router.navigate(["OneApp/" + item.path]);
      this.closeSearch();
    } else {
      this.toastr.warning(
        "Screen not available for selected item please select another item"
      );
    }
  }

  onItemDeSelect(item: any) { }

  closeSearch() {
    $("#staticBackdrop").modal("hide");
    this.selectedMenu = [];
  }
  mydocuments() {
    this.router.navigate(["/OneApp/misReports/myDocuments"]);
    if (window.matchMedia("(max-width: 991px)").matches) {
      setTimeout(() => this.closeLeftMenuforMobile(), 100);
    }
  }

  isUrlBasedLogo(): boolean {
    const tntLogo: any = localStorage.getItem("tnt_logo");
    return tntLogo?.length > 0 && tntLogo != "undefined";
  }

  loginInternship() {
    this.service
      .postCall("Enroll/CheckCourseRegisteredByUser", {
        STUDENT_PAYMENT_STUDENT_ID: localStorage.getItem("UserId"),
        TENANT_CODE: this.tenantCode,
      })
      .subscribe((res: any) => {
        if (res.message) {
          this.service.activateSpinner();
          const data = JSON.parse(sessionStorage.userData);
          let payload = {
            title: 38,
            firstname: data.FIRSTNAME,
            lastname: data.LASTNAME,
            mobileno: data.mobileno,
            username: data.USERNAME,
            dob: "2000-01-01",
            Gender: 1,
            TENANT_CODE: 58192556,
            UserType: 26,
            Role: 3,
            Timezone: "India Standard Time",
            CREATEDBY: data.USERID,
            Company_id: "51",
            RoleId: 26,
            origin: sessionStorage.getItem("internshipUrl"),
            internshipid: data.USERID,
          };
          const internUrl = sessionStorage.getItem("internshipUrl");
          const apiUrl = `${internUrl}api/Registration/InternshipRegistration`;
          this.http.post(apiUrl, payload).subscribe(
            (res: any) => {
              let loginData = {
                UserName: res.UserName,
                password: res.password,
              };
              const encodedData = btoa(JSON.stringify(loginData)); // Encode properly
              window.open(`${internUrl}login?data=${encodedData}`, "_blank");
              if (res.message === "Registration Successful" && res.status) {
                this.service
                  .postCall("Registration/UpdateUserByInternshipId", {
                    TenantCode: this.tenantCode,
                    UserId: localStorage.getItem("UserId"),
                    internship_userid: res?.userID,
                  })
                  .subscribe((res: any) => { });
              }
              this.service.deactivateSpinner();
            },
            (error) => {
              console.error("Error:", error);
              this.toastr.error("Something went wrong!");
              this.service.deactivateSpinner();
            }
          );
        } else {
          return this.toastr.error("Please register for course");
        }
      });

    // "https://oukinternship.dhanushinfotech.com/api/Registration/InternshipRegistration";
  }
  smartHr() {
    if (this.SMHRUrl.length && this.SMHRUrl != "null") {
      window.open(`${this.SMHRUrl}?SMHR=${localStorage.tkn}`);
      if (window.matchMedia("(max-width: 991px)").matches) {
        setTimeout(() => this.closeLeftMenuforMobile(), 100);
      }
    } else {
      this.toastr.warning("SMHR URL Not Found");
    }
  }
  get dashboardLink(): string {
    return sessionStorage.getItem("dashboard_path");
    // if ([1, 2106, 2083, 2084, 2093, 2092, 2105].includes(Number(this.roleId))) {
    //   return "/HOME/mainDashboard";
    // } else if (
    //   this.roleId === "2119" ||
    //   this.roleName === "Alumini" ||
    //   this.roleId === "2" ||
    //   this.roleId === "Mg=="
    // ) {
    //   return "/HOME/dashboard";
    // } else if (this.roleId == "3" && this.applicantId != "1") {
    //   return "/HOME/studentDashboard";
    // } else {
    //   return "/HOME/dashboard";
    // }
  }
}
